"use client"

import { useEffect } from "react"
import { setupSyncListener, processSyncQueue } from "@/lib/offline-sync"

export function SyncInitializer() {
  useEffect(() => {
    setupSyncListener()
    if (navigator.onLine) {
      processSyncQueue()
    }

    const handleOnline = () => {
      processSyncQueue()
    }

    window.addEventListener("online", handleOnline)

    return () => {
      window.removeEventListener("online", handleOnline)
    }
  }, [])

  return null
}
